import palette from '../palette';

export default {
  root: {
    fontWeight: 500,
    textTransform: 'uppercase',
  },
  contained: {
    boxShadow:
      '0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
    backgroundColor: '#FFFFFF',
    color: palette.text.primary,
    '&:hover': {
      backgroundColor: '#F5F5F5',
    },
    '&:active': {
      backgroundColor: '#EEEEEE',
    },
  },
  containedPrimary: {
    color: '#FFFFFF',
    backgroundColor: palette.primary.main,
    '&:hover': {
      backgroundColor: palette.primary.dark,
    },
    '&:active': {
      backgroundColor: palette.primary.dark,
    },
  },
};
